import { ref } from 'vue';

// Module-level bridge: Sidebar.vue publishes its computed `menuItems` here so the
// sibling SecondaryPanel.vue (two-tier nav) can reuse the exact same nav config
// (routes + permissions + dynamic items) without duplicating it.
export const sharedMenuItems = ref([]);
